/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { DateFieldComponent } from './date-field/date-field.component';
import { MomentModule } from 'ngx-moment';
import { LinkFieldComponent } from './link-field/link-field.component';
import { NumberFieldComponent } from './number-field/number-field.component';
import { ReportlinkFieldComponent } from './reportlink-field/reportlink-field.component';
import { VideoFieldComponent } from './video-field/video-field.component';
import { BaseFieldComponent } from './base-field.component';
import { StringFieldComponent } from './string-field/string-field.component';
import { TableDropdownComponent } from './tableEditControls/table-dropdown.component';
import { TableDbDropdownComponent } from './tableEditControls/table-db-dropdown.component';
import { SharedModule } from '../../../shared/shared.module';
import { ReportFilterService } from '../../services/report-filter.service';
import { DocumentLinkFieldComponent } from './document-link-field/document-link-field.component';
import { QrCodeFieldComponent } from './qr-code-field/qr-code-field.component';

@NgModule({
    declarations: [
        BaseFieldComponent,
        StringFieldComponent,
        DateFieldComponent,
        LinkFieldComponent,
        NumberFieldComponent,
        ReportlinkFieldComponent,
        VideoFieldComponent,
        TableDropdownComponent,
        TableDbDropdownComponent,
        DocumentLinkFieldComponent,
        QrCodeFieldComponent,
    ],
    exports: [
        BaseFieldComponent,
        StringFieldComponent,
        DateFieldComponent,
        LinkFieldComponent,
        NumberFieldComponent,
        ReportlinkFieldComponent,
        VideoFieldComponent,
        TableDropdownComponent,
        TableDbDropdownComponent,
    ],
    imports: [SharedModule, MomentModule],
    providers: [ReportFilterService],
})
export class ReportFieldsModule {}
